import { Group, ListProps } from '~/components/component-library'
import { ListCTA } from '~/components/component-library/List/components/ListCTA'
import { ListItem } from '~/components/component-library/List/components/ListItem'
import {
  EMPTY_STATE,
  LIST_CONTAINER,
} from '~/components/component-library/List/styles'

export type {
  ListProps,
  ListItemProps,
} from '~/components/component-library/List/types'

export const List = ({
  items,
  cta,
  description,
  emptyListText = 'No items',
  secondaryDisplay,
  footer,
  label,
  tooltip,
}: ListProps) => {
  const hasContent = items.length > 0 || !!cta
  return (
    <Group
      label={label ?? ''}
      secondaryDisplay={secondaryDisplay}
      footer={footer}
      description={description}
      tooltip={tooltip}
    >
      {hasContent ? (
        <ul tabIndex={-1} className={LIST_CONTAINER}>
          {items.map(({ key, ...props }) => (
            <ListItem key={key} {...props} />
          ))}
          {cta && <ListCTA {...cta} />}
        </ul>
      ) : (
        <div className={EMPTY_STATE}>{emptyListText}</div>
      )}
    </Group>
  )
}
